import { createPortal } from 'react-dom'

import { useCalendarHeaderActionsContainerContext } from '../Calendar.hooks'

// Only a page that gives the header's actions node (the Calendar section) shows what goes in here
function CalendarHeaderActionsPortal({ children }) {
  const container = useCalendarHeaderActionsContainerContext()

  return container ? createPortal(children, container) : null
}

export default CalendarHeaderActionsPortal
